<template>
  <div>
    <template v-if="inputData.formInputType === 'buttons'">
      <UlButtonsAeskulab
        v-if="inputData.identifier === 'which_person_aeskulab' && currentPath === 'aeskuLab'"
        :input-data="inputData"
        :form-name="formName"
        :step-id="stepId"
        @update:value="
          newValue => {
            $emit('update:value', newValue);
          }
        "
      />
      <UlButtonsTabs
        v-else-if="step.formStepType === 'personal_info'"
        :input-data="inputData"
        data-cy="dynamicFormInputUlButtonsTabs"
        :form-name="formName"
        :step-id="stepId"
        @update:value="
          newValue => {
            $emit('update:value', newValue);
          }
        "
      />
      <UlButtons
        v-else
        :input-data="inputData"
        :form-name="formName"
        :step-id="stepId"
        @update:value="
          newValue => {
            $emit('update:value', newValue);
          }
        "
      />
    </template>
    <UlDateSegmented
      v-if="inputData.formInputType === 'date'"
      :input-data="inputData"
      :form-name="formName"
      :gtm-form-name="gtmFormName"
      :parent-value-id="parentValueId"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <template v-if="inputData.formInputType === 'text'">
      <UlPhone
        v-if="inputData.inputValidation === 'phonenumber'"
        :input-data="inputData"
        :form-name="formName"
        :parent-value-id="parentValueId"
        :step-id="stepId"
        @update:value="
          () => {
            $emit('update:value');
          }
        "
      />
      <UlAddress
        v-else-if="inputData.inputValidation === 'address'"
        :input-data="inputData"
        :form-name="formName"
        :step-id="stepId"
        @update:value="
          () => {
            $emit('update:value');
          }
        "
      />
      <UlInput
        v-else
        :input-data="inputData"
        :store="store"
        :form-name="formName"
        data-cy="dynamicFormInputUlInput"
        :parent-value-id="parentValueId"
        :step-id="stepId"
        @update:value="
          () => {
            $emit('update:value');
          }
        "
      />
    </template>
    <UlTextarea
      v-if="inputData.formInputType === 'textarea'"
      :input-data="inputData"
      :store="store"
      data-cy="dynamicFormInputUlTextArea"
      :form-name="formName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlAttachmentProfile
      v-if="['file', 'file_id'].includes(inputData.formInputType)"
      :form-name="formName"
      :input-data="inputData"
      :store="store"
      :step-id="stepId"
      :has-padding="false"
    />
    <UlCheckbox
      v-if="inputData.formInputType === 'checkbox'"
      :input-data="inputData"
      data-cy="dynamicFormInputUlCheckbox"
      :store="store"
      :form-name="formName"
      :gtm-form-name="gtmFormName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlChoice
      v-if="inputData.formInputType === 'choice' && inputData.multipleValues"
      :input-data="inputData"
      :store="store"
      data-cy="dynamicFormInputUlChoice"
      :form-name="formName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlSelectDynamic
      v-if="inputData.formInputType === 'choice' && !inputData.multipleValues"
      :input-data="inputData"
      :store="store"
      class="ul-selectbox__container"
      :form-name="formName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlComboBox
      v-if="inputData.formInputType === 'select_searchable'"
      :input-data="inputData"
      :form-name="formName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlRadio
      v-if="inputData.formInputType === 'radio'"
      :input-data="inputData"
      :store="store"
      :form-name="formName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlPersonalDataAgreement
      v-if="inputData.formInputType === 'personaldata_agreement'"
      :input-data="inputData"
      :store="store"
      :form-name="formName"
      :gtm-form-name="gtmFormName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlTermsOfUseAgreement
      v-if="inputData.formInputType === 'termsofuse_agreement'"
      :input-data="inputData"
      :store="store"
      :form-name="formName"
      :gtm-form-name="gtmFormName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlSvgInput
      v-if="inputData.formInputType === 'svg_choice'"
      :input-data="inputData"
      :store="store"
      :form-name="formName"
      :step-id="stepId"
      @update:value="
        () => {
          $emit('update:value');
        }
      "
    />
    <UlTextOnly
      v-if="inputData.formInputType === 'text_only'"
      :input-data="inputData"
      :store="store"
      :form-name="formName"
    />
  </div>
</template>

<script>
import UlButtonsAeskulab from '@/components/Forms/Inputs/UlButtonsAeskulab';
import UlButtonsTabs from '@/components/Forms/Inputs/UlButtonsTabs';
import UlButtons from '@/components/Forms/Inputs/UlButtons';
import UlDateSegmented from '@/components/Forms/Inputs/UlDateSegmented';
import UlPhone from '@/components/Forms/Inputs/UlPhone';
import UlAddress from '@/components/Forms/Inputs/UlAddress';
import UlInput from '@/components/Forms/Inputs/UlInput';
import UlTextarea from '@/components/Forms/Inputs/UlTextarea';
import UlAttachmentProfile from '@/components/Forms/Inputs/UlAttachmentProfile';
import UlCheckbox from '@/components/Forms/Inputs/UlCheckbox';
import UlChoice from '@/components/Forms/Inputs/UlChoice';
import UlComboBox from '@/components/Forms/Inputs/UlComboBox';
import UlRadio from '@/components/Forms/Inputs/UlRadio';
import UlPersonalDataAgreement from '@/components/Forms/Inputs/UlPersonalDataAgreement';
import UlTermsOfUseAgreement from '@/components/Forms/Inputs/UlTermsOfUseAgreement';
import UlSvgInput from '@/components/Forms/Inputs/UlSvgInput';
import UlTextOnly from '@/components/Forms/Inputs/UlTextOnly';
import UlSelectDynamic from '@/components/Forms/Inputs/UlSelectDynamic';

export default {
  name: 'DynamicFormInput',
  components: {
    UlSelectDynamic,
    UlTextOnly,
    UlSvgInput,
    UlTermsOfUseAgreement,
    UlPersonalDataAgreement,
    UlRadio,
    UlComboBox,
    UlChoice,
    UlCheckbox,
    UlAttachmentProfile,
    UlTextarea,
    UlInput,
    UlAddress,
    UlPhone,
    UlDateSegmented,
    UlButtons,
    UlButtonsTabs,
    UlButtonsAeskulab
  },
  props: {
    step: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    },
    inputData: {
      type: Object,
      required: true
    },
    store: {
      type: String,
      required: true
    },
    formName: {
      type: String,
      required: true
    },
    gtmFormName: {
      type: String,
      required: false
    },
    parentValueId: {
      type: Number,
      default: null
    }
  }
};
</script>
